<template>
  <el-dialog
    :title="title"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    fullscreen
    destroy-on-close
  >
    <div>
      <el-row>
        <el-col :span="8">
          <div style="text-align: left; margin-right: 16px">
            <div>
              <el-form :model="form" :size="size" label-width="120px">
                <el-form-item :label="$t('areatype.title')">
                  <el-radio-group v-model="AreaType">
                    <el-radio :label="0">{{
                      $t("areatype.circular")
                    }}</el-radio>
                    <el-radio :label="1">{{
                      $t("areatype.rectangle")
                    }}</el-radio>
                    <el-radio :label="2">{{ $t("areatype.polygon") }}</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="">
                  <el-button @click="drawArea" type="primary">{{
                    drawing
                      ? $t("arealimitset.cancelareaset")
                      : $t("arealimitset.clickareaset")
                  }}</el-button
                  ><span
                    style="margin-left: 6px; color: #a2b1cb; font-size: 12px"
                    >{{ $t("arealimitset.opeinmap") }}</span
                  >
                </el-form-item>
                <el-form-item :label="$t('arealimitset.areaname')">
                  <el-input v-model="AreaName"></el-input>
                </el-form-item>
                <el-form-item :label="$t('arealimitset.enValidTime')">
                  <el-switch active-color="#13ce66" v-model="UsingTime">
                  </el-switch>
                </el-form-item>
                <el-form-item :label="$t('time.startTimeHolder')">
                  <el-date-picker
                    :disabled="!UsingTime"
                    v-model="BeginTime"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :placeholder="$t('arealimitset.selectDateTime')"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('time.endTimeHolder')">
                  <el-date-picker
                    :disabled="!UsingTime"
                    v-model="EndTime"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :placeholder="$t('arealimitset.selectDateTime')"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('arealimitset.enterAreaAlarm')">
                  <el-checkbox v-model="EnterAlarmToCenter">{{
                    $t("arealimitset.enterAlarmToCenter")
                  }}</el-checkbox>
                  <el-checkbox v-model="EnterAlarmToDriver">{{
                    $t("arealimitset.enterAlarmToDriver")
                  }}</el-checkbox>
                </el-form-item>
                <el-form-item :label="$t('arealimitset.outAreaAlarm')">
                  <el-checkbox v-model="OutAlarmToCenter">{{
                    $t("arealimitset.enterAlarmToCenter")
                  }}</el-checkbox>
                  <el-checkbox v-model="OutAlarmToDriver">{{
                    $t("arealimitset.enterAlarmToDriver")
                  }}</el-checkbox>
                </el-form-item>
                <el-form-item :label="$t('alarm.alarmType2')">
                  <el-switch active-color="#13ce66" v-model="OverSpeedToCenter">
                  </el-switch>
                </el-form-item>
                <el-form-item :label="$t('arealimitset.maxSpeed')">
                  <el-input-number
                    :disabled="!OverSpeedToCenter"
                    v-model="MaxSpeed"
                    :min="30"
                    :max="100"
                  ></el-input-number>
                  <span
                    style="margin-left: 6px; color: #a2b1cb; font-size: 12px"
                    >km/h({{ $t("public.EffectiveRange") }}:30~100)</span
                  >
                </el-form-item>
                <el-form-item :label="$t('arealimitset.overSpeedTime')">
                  <el-input-number
                    :disabled="!OverSpeedToCenter"
                    v-model="Duration"
                    :min="5"
                    :max="10"
                  ></el-input-number>
                  <span
                    style="margin-left: 6px; color: #a2b1cb; font-size: 12px"
                    >{{ $t("time.second") }}({{ $t("public.EffectiveRange") }}:5~10)</span
                  >
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="onSaveClick" :size="size">{{
                    $t("public.save")
                  }}</el-button>
                  <el-button @click="dialogVisible = false" :size="size">{{
                    $t("public.cancel")
                  }}</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-col>
        <el-col :span="16" style="height: calc(100vh - 100px)">
          <KingLongMap
            ref="map"
            mapId="content_remind"
            @DrawRectangleCompleted="DrawRectangleCompleted"
            @LoadCompleted="mapLoadCompleted"
            @DrawPolygonCompleted="DrawPolygonCompleted"
            @DrawCircleCompleted="DrawCircleCompleted"
          />
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
import KingLongMap from "@/components/KingLongMap.vue";
export default {
  components: { KingLongMap },
  computed: {
    size() {
      return this.$store.getters.size;
    },
    operator() {
      return this.$store.getters.operator;
    },
  },

  data() {
    return {
      title: this.$t("arealimitset.addElectronicFence"),
      dialogVisible: false,
      drawing: false, //正在绘制区域中

      EnterAlarmToCenter: false,
      EnterAlarmToDriver: false,
      OutAlarmToCenter: false,
      OutAlarmToDriver: false,
      OverSpeedToCenter: false,
      UsingTime: false,

      BeginTime: "",
      EndTime: "",

      MaxSpeed: 40,
      Duration: 5,
      AreaType: 2,
      AreaID: -1,
      AreaName: "",
      UseState: 1,
      Lonlats: "",
      AddedInfo: "",
      AreaAttribute: 0, //0x0500 如何计算

      mapLoaded: false,
    };
  },
  methods: {
    add() {
      this.edit({});
      this.AreaID = -1;
      this.AreaName = "";
      this.AreaType = 2;
      this.UsingTime = false;
      this.EnterAlarmToCenter = false;
      this.EnterAlarmToDriver = false;
      this.OutAlarmToCenter = false;
      this.OutAlarmToDriver = false;
      this.OverSpeedToCenter = false;
      this.BeginTime = "";
      this.EndTime = "";
      this.Lonlats = "";
      this.AddedInfo = "";

      this.MaxSpeed = 40;
      this.Duration = 5;
      this.UseState = 1;

      this.AreaAttribute = 0;
      this.title = this.$t("arealimitset.addElectronicFence");
    },
    edit(row) {
      this.form = Object.assign({}, row);
      this.AreaType = row.AreaType;
      this.AreaID = row.AreaID;
      this.AreaName = row.AreaName;

      this.UseState = row.UseState;
      this.Lonlats = row.Lonlats;
      this.AddedInfo = row.AddedInfo;
      this.AreaAttribute = row.AreaAttribute;

      this.title = this.$t("arealimitset.editElectronicFence");

      //根据AreaAttribute计算显示
      if (row && row.AreaAttribute) {
        this.UsingTime = (row.AreaAttribute & 0x01) != 0;
        this.OverSpeedToCenter = (row.AreaAttribute & 0x02) != 0;
        this.EnterAlarmToCenter = (row.AreaAttribute & 0x08) != 0;
        this.EnterAlarmToDriver = (row.AreaAttribute & 0x04) != 0;
        this.OutAlarmToCenter = (row.AreaAttribute & 0x20) != 0;
        this.OutAlarmToDriver = (row.AreaAttribute & 0x10) != 0;
      }
      this.BeginTime = row.BeginTime || "";
      this.EndTime = row.EndTime || "";

      this.MaxSpeed = row.MaxSpeed || 40;
      this.Duration = row.Duration || 5;

      this.dialogVisible = true;
      // if (this.mapLoaded) {
      setTimeout(() => {
        this.showArea();
      }, 500);
      // }
    },
    mapLoadCompleted() {
      console.log("mapLoadCompleted");
      if (!this.mapLoaded) {
        this.mapLoaded = true;
      }
      // this.$nextTick(() => {
      //     this.showArea();
      //   });
    },
    showArea() {
      this.$refs.map.clearAll();

      if (this.Lonlats || this.AddedInfo) {
        switch (this.AreaType) {
          case 0:
            var circleInfo = this.AddedInfo.split(",");
            if (circleInfo.length == 3) {
              this.$refs.map.addCircle(
                this.AreaID,
                { lng: circleInfo[1], lat: circleInfo[2] },
                circleInfo[0]
              );
            }

            break;
          case 1: //矩形
            //todo  缩放到适当的区域
            var circleInfo = this.Lonlats.split(";");

            var ne = circleInfo[0].split(",");
            var sw = circleInfo[1].split(",");

            var lon = (parseFloat(ne[1]) + parseFloat(sw[1])) / 2;
            var lat = (parseFloat(ne[2]) + parseFloat(sw[2])) / 2;

            var coordanites = [];
            coordanites.push({
              lng: parseFloat(ne[1]),
              lat: parseFloat(ne[2]),
            });
            coordanites.push({
              lng: parseFloat(ne[1]),
              lat: parseFloat(sw[2]),
            });
            coordanites.push({
              lng: parseFloat(sw[1]),
              lat: parseFloat(sw[2]),
            });
            coordanites.push({
              lng: parseFloat(sw[1]),
              lat: parseFloat(ne[2]),
            });

            this.$refs.map.addPolygon(
              "AREA1",
              this.AreaName,
              coordanites,
              3,
              0xcd3700,
              0xb3ee3a
            );

            break;
          case 2: //多边形
            //todo  缩放到适当的区域
            var circleInfo = this.Lonlats.split(";");

            var center = circleInfo[0].split(",");

            var coordanites = [];
            circleInfo.forEach((element) => {
              var p = element.split(",");
              coordanites.push({
                lng: parseFloat(p[1]),
                lat: parseFloat(p[2]),
              });
            });

            this.$refs.map.addPolygon(
              "AREA1",
              this.AreaName,
              coordanites,
              3,
              0xcd3700,
              0xb3ee3a
            );
            break;
        }
      }
    },
    onSaveClick() {
      //数据保存
      //非空判断
      if (this.AreaName === "") {
        this.$message.warning(this.$t("arealimitset.areanameempty"));
        return;
      } else if (this.MaxSpeed == "") {
        this.$message.warning(this.$t("arealimitset.arealimitempty"));
        return;
      } else if (this.MaxSpeed < 30 || this.MaxSpeed > 100) {
        this.$message.warning(this.$t("arealimitset.higherspeedrange"));
        return;
      }
      if (!this.AddedInfo && !this.Lonlats) {
        this.$message.warning(this.$t("arealimitset.areaempty"));
        return;
      }

      this.convertAreaAttribute();
      //保存到数据库

      this.$api
        .saveOverSpeedRemindArea({
          AreaID: this.AreaID,
          AreaName: this.AreaName,
          AreaType: this.AreaType,
          AreaAttribute: this.AreaAttribute,
          BeginTime: this.BeginTime,
          EndTime: this.EndTime,
          MaxSpeed: this.MaxSpeed,
          Duration: this.Duration,
          AddedInfo: this.AddedInfo,
          OperatorID: this.operator.OperatorId,
          CompanyID: this.operator.CompanyId,
          lonlats: this.Lonlats,
          UseState: this.UseState,
        })
        .then((res) => {
          this.$message.success(this.$t("public.hasSaved"));
          this.$emit("ok");
          this.dialogVisible = false;
        });
      //重新加载列表
    },
    convertAreaAttribute() {
      var result = 0x0000;
      if (this.UsingTime) result += 1;
      if (this.OverSpeedToCenter) result += 2;
      if (this.EnterAlarmToDriver) result += 4;
      if (this.EnterAlarmToCenter) result += 8;
      if (this.OutAlarmToDriver) result += 16;
      if (this.OutAlarmToCenter) result += 32;
      this.AreaAttribute = result;
    },
    DrawRectangleCompleted(lng1, lat1, lng2, lat2) {
      this.drawing = false;
      this.Lonlats = "1," + lng1 + "," + lat1 + ";" + "2," + lng2 + "," + lat2;
      this.AddedInfo = "";
    },
    DrawPolygonCompleted(lnglats) {
      this.drawing = false;
      var aryPoint = lnglats.split(";");
      if (aryPoint.length > 125) {
        //绘制多边形节点不能超出上限125个
        return;
      }

      var lonlats = "";
      for (var i = 0; i < aryPoint.length; i++) {
        if (lonlats != "") lonlats += ";";
        lonlats += i + "," + aryPoint[i];
      }

      this.Lonlats = lonlats;
      this.AddedInfo = "";
    },

    DrawCircleCompleted(lng, lat, radius) {
      this.drawing = false;
      this.Lonlats = "";
      this.AddedInfo = radius + "," + lng + "," + lat;
    },

    drawArea() {
      //画区域
      if (this.drawing) {
        //正在画，取消画
        this.$refs.map.cancelDraw();
        this.drawing = false;
      } else {
        //根据选中类型进行
        switch (this.AreaType) {
          case 0:
            this.$refs.map.drawCircle();
            break;
          case 1:
            this.$refs.map.drawRectangle();
            break;
          case 2:
            this.$refs.map.drawPolygon();
            break;
        }

        this.drawing = true;
      }
    },
  },
};
</script>
